import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MarkdownModule, MarkedOptions, MarkedRenderer } from 'ngx-markdown';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ChatComponent } from './containers/chat/chat.component';
import { AnswerRatingComponent } from './components/answer-rating/answer-rating.component';
import { HumanAssistanceRequestComponent } from './components/human-assistance-request/human-assistance-request.component';
import { UserInfoQueryComponent } from './components/user-info-query/user-info-query.component';
import { bffAuthProviders } from './bff-auth.config';
import { MessageBoxComponent } from './components/message-box/message-box.component';
import { LegalDocumentsComponent } from './components/legal-documents/legal-documents.component';
import { SourcePillsComponent } from './components/source-pills/source-pills.component';

export function markedOptionsFactory(): MarkedOptions {
  const renderer = new MarkedRenderer();

  renderer.blockquote = (text: string) => {
    return '<blockquote class="blockquote"><p>' + text + '</p></blockquote>';
  };

  const linkRenderer = renderer.link;
  renderer.link = (href, title, text) => {
    const html = linkRenderer.call(renderer, href, title, text);
    return html.replace(/^<a /, '<a target="_blank" rel="nofollow" ');
  };

  return {
    renderer: renderer,
    gfm: true,
    breaks: false,
    pedantic: false,
    smartLists: true,
    smartypants: false,
  };
}

@NgModule({
  declarations: [
    AppComponent, 
    ChatComponent, 
    AnswerRatingComponent, 
    HumanAssistanceRequestComponent, 
    UserInfoQueryComponent,
    SourcePillsComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    MatTooltipModule,
    MarkdownModule.forRoot({
      markedOptions: {
        provide: MarkedOptions,
        useFactory: markedOptionsFactory,
      },
    }),
    MessageBoxComponent,
    LegalDocumentsComponent,
  ],
  providers: [
    ...bffAuthProviders,
    { provide: 'Window',  useValue: window }
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
